/**
 * @module builder
 */
import type { UpdateableProduct } from '../../index'

export function getProductLabel(product: UpdateableProduct): string {
  return [product.label, product.color].filter((item) => item).join(' - ')
}
